import { Fragment, useContext, useRef, useState,useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import "react-country-state-city/dist/react-country-state-city.css";
import axios from '../../axios'
import {toast} from 'react-toastify'
import Batch from '../Dropdowns/Batch'
import  UploadImage from '../UploadImage'
import Centre from '../Dropdowns/Centre'
export default function AddProduct({
  addProductModalSetting,
  stbn,
  bstudent,
  handlePageUpdate,
}) {
  const auth = useContext(AuthContext);
 const[cheque,setCheque]=useState('')
 const[sgender,setGender]=useState('')
 const[profile,setProfile]=useState('')
 const[document,setDocument]=useState('')
 const[casteCerti,setCasteCerti]=useState('')
 const[mstatus,setMstatus]=useState('')
const[tbn,setTbn]=useState('')
const[centre,setCentre]=useState('')
const[caste,setCaste]=useState('')
const[update,setUpdate]=useState(false)
const imp=true
  const [student, setStudent] = useState({
  fullname:'',
  contact_no:'',
  age:'',
  upsdm_id:'',
  attendee_id:'',
  email:'',
  permenent_address:'',
  mailing_address:'',
  qualification:'',
  dob:'',
  mother_name:'',
  guardian_name:"",
  religion:'',
  district:'',
  city:'',
  aadhar_no:'',
  bank_name:'',
  ifsc_code: '' ,
  account_no:'',
  branch:'',
  pan_no:'',
  designation:''

});
const [isButtonDisabled, setIsButtonDisabled] = useState(false);
useEffect(() => {
  if (student.dob) {
    const today = new Date();
    const birthDate = new Date(student.dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    setStudent((prevState) => ({
      ...prevState,
      age: age
    }));
  }
}, [student.dob]);
const handleChequeChange = (e) => {
  setCheque(e.target.files[0]);
};
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const handleProfileChange = (e) => {
    setProfile(e.target.files[0]);
  };
  const handleDocumentChange = (e) => {
    setDocument(e.target.files[0]);
  };
  const handleCasteCertiChange = (e) => {
    setCasteCerti(e.target.files[0]);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStudent((prevStudent) => ({
      ...prevStudent,
      [name]: value
    }));
  };
  const batchId=bstudent?stbn:tbn
  const addstudent= () => {
    setIsButtonDisabled(true); 

    const formData=new FormData()
    if(batchId!==''){
      formData.append('batch_id', batchId)
    }
    formData.append('upsdm_id', student.upsdm_id)
    formData.append('attendee_id', student.attendee_id)
    formData.append('fullname', student.fullname)
    formData.append('contact_no', student.contact_no)
    formData.append('age', student.age)
    formData.append('gender',sgender)
    formData.append('email', student.email)
    formData.append('permenent_address', student.permenent_address)
    formData.append('mailing_address', student.mailing_address)
    formData.append('qualification', student.qualification)
    formData.append('dob', student.dob)
    formData.append('mother_name', student.mother_name)
    formData.append('guardian_name', student.guardian_name)
    formData.append('district', student.district)
    formData.append('city', student.city)
    formData.append('aadhar_no', student.aadhar_no)
    formData.append('bank_name', student.bank_name)
    formData.append('ifsc_code', student.ifsc_code)
    formData.append('bank_acc_no', student.account_no)
    formData.append('branch', student.branch)
    formData.append('pan_no', student.pan_no)
    formData.append('cancel_cheque', cheque)
    formData.append('caste', caste)
    formData.append('cast_certificate', casteCerti)
    formData.append('marital_status',mstatus)
    formData.append('religion',student.religion)
    formData.append('image', profile)
    formData.append('designation',student.designation)
    formData.append('documents', document)
   
 axios.post(`students/insert`,formData)
    .then(res => {
      toast.success("Student Added Successfully")
      addProductModalSetting();
      handlePageUpdate();
      
    })
    .catch(err => {
      console.log(err);
    })
    .finally(() => {
      setIsButtonDisabled(false); // Re-enable the button after toast is displayed
    });
  };
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Add Student
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                          
                         {!bstudent&&(
                          <>
                           {(auth.userType==='Superadmin'|| auth.userType==='Manager')&&(
                            <Centre value={centre} handleInputChange={e=>{setCentre(e.target.value);setUpdate(!update)}} />
                          )}
                          <div>
                            <Batch value={tbn} handleInputChange={e=>{setTbn(e.target.value);setUpdate(!update)}} centre={centre} />
                            </div>
                        
                          </>
                         )}
                        <div>
                          <label
                          htmlFor="student"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >Student Photo</label>
                          <UploadImage uploadImage={handleProfileChange} fileName={profile}/>
                              </div>
                          <div>
                            <label 
                              htmlFor="fullname"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                            Name 
                            </label>
                            <input 
                            type="text"
                            name="fullname"
                            id="fullname"
                            value={student.fullname}
                            onChange={handleInputChange}
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                                htmlFor="dob"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date of Birth 
                              </label>
                              <input
                               type="date"
                               id="dob"
                               name="dob"
                               value={student.dob|| `${new Date().getFullYear()-25}-01-01`}
                               onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                               :focus:border-blue-500"
                               
                               />
                            </div>
                            <div>
                            <label
                                htmlFor="upsdm_id"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Candidate ID 
                              </label>
                              <input
                               type="number"
                               id="upsdm_id"
                               name="upsdm_id"
                               value={student.upsdm_id}
                               onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                               :focus:border-blue-500"
                          
                               />
                            </div>
                            <div>
                            <label
                                htmlFor="attendee_id"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                SIP ID 
                              </label>
                              <input
                               type="number"
                               id="attendee_id"
                               name="attendee_id"
                               value={student.attendee_id}
                               onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                               :focus:border-blue-500"
                            
                               />
                            </div>
                            <div>
                            <label
                                htmlFor="age"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Age 
                              </label>
                              <input
                               type="number"
                               id="age"
                               name="age"
                               value={student.age}
                               onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                               :focus:border-blue-500"
                               />
                            </div>
                            <div>
                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" 
                            htmlFor="sgender">
        Gender 
      </label>
        <select
          id="sgender"
          onChange={(e)=>setGender(e.target.value)}
          value={sgender}
                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value='' disabled>Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        </div>  
      
                            </div>
                            <div>
                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" 
                            htmlFor="caste">
        Caste 
      </label>
        <select
          id="caste"
          onChange={(e)=>setCaste(e.target.value)}
          value={caste}
                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value='' disabled>Select Caste</option>
          <option value="Gen">General</option>
          <option value="OBC">OBC</option>
          <option value="SC/ST">SC/ST</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        </div>  
      
                            </div>
                            {(caste!=='Gen' && caste!=='')&&(
                                       <div>
                                       <label htmlFor="casteCerti"
                                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                       >Caste Certificate</label>
                                      <label
                   htmlFor="casteCerti"
                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
                   <svg
                     className="w-6 h-5 inline-block mr-2"
                     viewBox="0 0 24 24"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                   >
                     <path
                       d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
                       fill="currentColor"
                     />
                   </svg>
                   <span className="inline-block">
                     {" "}
                     {casteCerti?.name && casteCerti.name.length > 8
                       ? casteCerti.name.substring(0, 8) + "..."
                       : casteCerti?.name || "Choose file"}
                   </span>
                 </label>
                 <input
                   type="file"
                   id="casteCerti"
                   className="hidden"
                   accept=".png, .jpeg, .jpg .pdf"
                   required
                   onChange={handleCasteCertiChange}
                 />
                                     </div>
                            )}
                                                     <div >
      <label  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" htmlFor="marital-status">
        Marital Status
      </label>
      <div >
        <select
          id="marital-status"
          onChange={(e)=>{
            setMstatus(e.target.value)
          }}
          value={mstatus}
      className="bg-gray-50 border border-gray-300 text-gratty-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option value="" disabled>Select your status</option>
          <option value="Unmarried">Unmarried</option>  
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Widowed">Widowed</option>
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        </div>
      </div>
    </div>
                          <div>
                            <label
                              for="qualifications"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Qualifications 
                            </label>
                            <input
                              type="text"
                              name="qualification"
                              id="qualification"
                              value={student.qualification}
                              onChange={handleInputChange}
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            
                            />
                          </div>
                          <div>
                          <label 
                          htmlFor="district"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                District 
          </label>
          <input
            type="text"
            id="district"
            name="district"
            value={student.district}
            onChange={handleInputChange}
           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
/>
                            </div>
                            <div>
                            <label
                              htmlFor="city"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                          City 
                            </label>
                            <input
                              type="text"
                              name="city"
                              id="city"
                              value={student.city}
                              onChange={handleInputChange}
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                          </div>
                            <div>
                              <label
                                htmlFor="permenent_address"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                               Permanent Address 
                              </label>
                              <input
                                type="text"
                                id="permenent_address"
                                name="permenent_address"
                                value={student.permenent_address}
                                onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                            <div>
                              <label
                                htmlFor="mailing_address"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                              Mailing  Address 
                              </label>
                              <input
                                type="text"
                                id="mailing_address"
                                name="mailing_address"
                                value={student.mailing_address}
                                onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                           
                            
                           
                            <div>
                              <label htmlFor="email"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                               >
                                Email 
                               </label>
                               <input type="email"
                              id="email"
                              name="email"
                              value={student.email}
                              onChange={handleInputChange}
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

                              />
                            </div>
                            <div>
                            <label
                              htmlFor="pan_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Pan No.
                            </label>
                            <input
                            type="text"
                            name="pan_no"
                            id="pan_no"
                            value={student.pan_no}
                            onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                            <div>
                              <label htmlFor="contact_no" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Mobile No. 
                                </label>
                              <input type="number"
                              id="contact_no"
                              name="contact_no"
                              value={student.contact_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            <div>
                              <label htmlFor="aadhar_no"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >Aadhar No.</label>
                              <input
                              type="number"
                              id="aadhar_no"
                              name="aadhar_no"
                              value={student.aadhar_no}
                              onChange={handleInputChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                              :focus:border-blue-500"
                              />
                            </div>
                            <div>
                            <label
                              htmlFor="guardian_name"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Guardian Name 
                            </label>
                            <input 
                            type="text"
                            name="guardian_name"
                            id="guardian_name"
                            value={student.guardian_name}
                            onChange={handleInputChange}
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                          <div>
                            <label
                              htmlFor="mother_name"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Mother Name 
                            </label>
                            <input 
                            type="text"
                            name="mother_name"
                            id="mother_name"
                            value={student.mother_name}
                            onChange={handleInputChange}
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              
                              />
                          </div>
                         


                          <div>
                            <label
                              htmlFor="religion"
                             className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                             Religion 
                            </label>
                           <input type='text'
                            name="religion"
                            id="religion"
                            value={student.religion}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            />
                           </div>
                           <div>
                            <label htmlFor="bank_name"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Name </label>
                            <input
                            type="text"
                            name="bank_name"
                            id="bank_name"
                            value={student.bank_name}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
                            <label htmlFor="account_no"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Bank Account No. </label>
                            <input
                            type="number"
                            name="account_no"
                            id="account_no"
                            value={student.account_no}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                          <div>
      <label
        htmlFor="ifsc_code"
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        Bank IFSC Code 
      </label>
      <input
        type="text"
        name="ifsc_code"
        id="ifsc_code"
        value={student.ifsc_code}  // Bind value to state
        onChange={handleInputChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
      />
    </div>
                          <div>
                            <label htmlFor="branch"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Branch Name </label>
                            <input
                            type="text"
                            name="branch"
                            id="branch"
                            value={student.branch}
                            onChange={handleInputChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                          focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5  "
                            />  
                          </div>
                           <div>
                            <label htmlFor="cheque"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Cancelled Cheque</label>
                           <label
        htmlFor="cheque"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {cheque?.name && cheque.name.length > 8
            ? cheque.name.substring(0, 8) + "..."
            : cheque?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="cheque"
        className="hidden"
        accept=".png, .jpeg, .jpg .pdf"
        required
        onChange={handleChequeChange}
      />
                          </div>
                          <div>
                            <label htmlFor="document"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >Documents </label>
                            <label
        htmlFor="document"
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"      >
        <svg
          className="w-6 h-5 inline-block mr-2"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 16V21H21V16H3ZM5 18H19V16H5V18ZM3 6H21V14H3V6ZM5 10H19V8H5V10Z"
            fill="currentColor"
          />
        </svg>
        <span className="inline-block">
          {" "}
          {document?.name && document.name.length > 8
            ? document.name.substring(0, 8) + "..."
            : document?.name || "Choose file"}
        </span>
      </label>
      <input
        type="file"
        id="document"
        className="hidden"
        accept=".pdf"
        required
        onChange={handleDocumentChange}
      />
                          </div>
                                </div>
                                <div className="flex items-center space-x-4">
                       
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                          <button
                            type="button"
                            className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                            onClick={addstudent}
                            disabled={isButtonDisabled}

                          >
                          {isButtonDisabled ? 'Adding...' : 'Add Student'}

                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            onClick={() => addProductModalSetting()}
                            
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
          );
        }
      